(function () {
    'use strict';

    // @ngInject
    function GoogleRedirectControllerCtor($scope, $injector, $location, $log, $q, InitialAppLoadParamsService, AnalyticsService, AppStates, UsersManager, PopupMessageService, AbTestService, Enums) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'GoogleRedirectController';
        AnalyticsService.trackPageView(this, 'GoogleRedirectView');
        this.$log = $log;
        this.$q = $q;

        this.AppStates = AppStates;
        this.UsersManager = UsersManager;
        this.user = this.UsersManager.getCurrUser();
        this.PopupMessageService = PopupMessageService;
        this.AnalyticsService = AnalyticsService;

        this.AbTestService = AbTestService;
        this.Enums = Enums;

        var queryStringParams = InitialAppLoadParamsService.getAllLoadParams();
        this.$log.info("queryStringParams debug: " + JSON.stringify(queryStringParams));
        InitialAppLoadParamsService.cleanParamsFromView(['state', 'code', 'error']);

        // saved the auth on the server model can now continue and return to the page we stated from.
        var stateAsObject = JSON.parse(queryStringParams.state);

        if (stateAsObject && queryStringParams.code) {
            this.UsersManager.setGoogleAuthCode(queryStringParams.code, stateAsObject.integration_type)
                .then(function success() {
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.save_gmail_integration_auth_code, {source: stateAsObject.origin_state});

                    switch (stateAsObject.origin_state) {
                        case 'calendar':
                            this.goToState(this.AppStates.root_core_navigation_calendar, {googleIntegrationCreated: true});
                            this.$log.log('switching to the calendar view');
                            break;
                        case 'gmail':
                            return this.setActiveEmailProvider().then(function success() {
                                this.goToState(this.AppStates.root_core_navigation_settings_company_integrations, {googleIntegrationCreated: true});
                                this.$log.log('switching to the account view on the setting');
                            }.bind(this));
                        case 'contacts':
                            this.goToState(this.AppStates.root_core_navigation_contacts, {googleIntegrationCreated: true});
                            this.$log.log('switching to the contacts view');
                            break;
                        case 'connections':
                            this.goToState(this.AppStates.root_core_navigation_creatives, {googleIntegrationCreated: true});
                            this.$log.log('switching to the creatives view');
                            break;
                        case 'referrals':
                            this.goToState(this.AppStates.root_core_navigation_invite_referrals, {googleIntegrationCreated: true});
                            this.AnalyticsService.trackRedirect(this, this.AnalyticsService.analytics_events.referral_dashboard);
                            this.$log.log('switching to the referral dashboard view');
                            break;
                        default:
                            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._TRY_AGAIN_');
                            this.$log.error('could not identify the origin_state code. this should not happen');
                            break;
                    }

                }.bind(this))
                .catch(function fail(resp) {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.save_gmail_integration_auth_code, resp);
                    if (resp && resp.data && resp.data.error_type && resp.data.error_message && resp.data.error_type === "HBGoogleIntegrationNotGmailError") {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message, function onPopupConfirm() {
                            this.goBackToPreviousStateOnError(stateAsObject);
                        }.bind(this));
                    }
                    else if (resp && resp.data && resp.data.error_type && resp.data.error_message && resp.data.error_type === "HBGoogleIntegrationMismatchedEmailError") {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message, function onPopupConfirm() {
                            this.goBackToPreviousStateOnError(stateAsObject);
                        }.bind(this));
                    }
                    else {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._TRY_AGAIN_', function onPopupConfirm() {
                            this.goBackToPreviousStateOnError(stateAsObject);
                        }.bind(this));
                    }

                    this.$log.error('failed to save the auth-code on the googe integration model');
                }.bind(this));

        } else if (queryStringParams.error) {
            this.$log.error('Error in google authentication process: ' + $location.url());
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.gmail_integration_google_error);
            
            this.$log.error('user rejected the permissions on google authentication page');
            if (stateAsObject) {
                // if we are here this means that the user has pressed deny on the google authentication page.
                // simply go back to where the user started from.
                this.goBackToPreviousStateOnError(stateAsObject);
            } else {
                //we dont have the origin state for some reason... to the pipeline we go...
                this.$log.error('could not identify the origin_state code. this should not happen');
                this.goToState(AppStates.root_core_navigation_pipeline);
            }
        }
    }

    Controllers.GoogleRedirectController = Class(Controllers.BaseController, {
        constructor: GoogleRedirectControllerCtor,

        setActiveEmailProvider: function setActiveEmailProvider() {
            return this.UsersManager.setActiveEmailProvider(this.user, 'gmail');
        },

        goBackToPreviousStateOnError: function goBackToPreviousStateOnError(stateObject) {
            switch (stateObject.origin_state) {
                case 'calendar':
                    this.goToState(this.AppStates.root_core_navigation_calendar);
                    break;
                case 'gmail':
                    this.goToState(this.AppStates.root_core_navigation_settings_company_integrations);
                    break;
                case 'contacts':
                    this.goToState(this.AppStates.root_core_navigation_contacts);
                    break;
                default:
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._TRY_AGAIN_', function onPopupConfirm() {
                        this.goToState(this.AppStates.root_core_navigation_pipeline);
                    }.bind(this));
                    this.$log.error('could not identify the origin_state code. this should not happen');
                    break;
            }
        }
    });
}());

Function.ubind = function (self) {
    var f = this;
    return function () {
        f.apply(self, Array.prototype.slice.call(arguments, 0));
    };
};
